module.exports = __webpack_public_path__ + "static/media/Olympiad.17e91d0f.png";